export default "__VITE_ASSET__be524c8f__"